<div class="popup-wrapper" [class.close]="close">
    <div class="popup-content">
        <h1>{{ headline }}</h1>
        <p>{{ text }}</p>
        <div class="buttons">
            <button (click)="closePopup()">Zur Ausstellung</button>
            <button *ngIf="customButton" (click)="openLink()">{{ customButtonText}}</button>
        </div>
    </div>
</div>
